// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transition-container[data-v-50e4571a]{--gzb6vl:0.2s}", ""]);
// Exports
module.exports = exports;
